import React, {useState, useEffect} from 'react';
import Switch from 'react-switch';
import axios from 'axios';
import {
	constraseñaErronea,
	emailErroneo,
	codigoPostalErroneo,
	telefonoErroneo,
	datosVacio,
} from '../../fuctions/validacionFormularios';
import {ModalesRegistro} from './ModalesRegistro';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import logo from '../../assets/CuidatiaNuevo2026.png';
import {useNavigate} from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import {ContentPoliticaPrivacidad} from '../varios/ContentPoliticaPrivacidad';
import Select from 'react-select';

export const FormularioRegistroEstandar = (props) => {
	/* Using the useNavigate hook to navigate to a different page. */
	const navigate = useNavigate();

	const [enviando, setEnviando] = useState(false);

	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* Setting the state of the variable UsuarioCliente to an object with the properties nombre,
    apellidos, telefono, email, password, password2 and username. */
	const [UsuarioCliente, setUsuarioCliente] = useState({
		nombre: '',
		apellidos: '',
		telefono: '',
		email: '',
		password: '',
		password2: '',
		username: '',
	});

	/* Declaring a variable called PoliticaPrivacidad and setting it to false. */
	const [PoliticaPrivacidad, setPoliticaPrivacidad] = useState(false);

	/* A state variable that is set to false. */
	const [MostartPoliticaPrivacidad, setMostartPoliticaPrivacidad] = useState(false);

	/* Setting the state of the variable ModalErrores to false. */
	const [ModalErrores, setModalErrores] = useState(false);

	/* Setting the state of the variable ModalRegistraPaciente to false. */
	const [ModalRegistraPaciente, setModalRegistrarPaciente] = useState(false);

	/* Setting the state of the variable ErroresFormulario to an empty array. */
	const [ErroresFormulario, setErroresFormulario] = useState([]);

	const [showPassword, setShowPassword] = useState(false);
	const mostrarPassword = () => setShowPassword(!showPassword);
	
	const [showPassword2, setShowPassword2] = useState(false);
	const mostrarPassword2 = () => setShowPassword2(!showPassword2);

	/* Declaring a variable called FotoPerfil and setting it to null. */
	const [FotoPerfil, setFotoPerfil] = useState(null);

	const [ListaLocalidades, setListaLocalidades] = useState([]);
	const [ListaLocalidadesOpciones, setListaLocalidadesOpciones] = useState([]);

	/**
	 * OnHandleChange is a function that takes an event as an argument and sets the state of
	 * UsuarioCliente to the value of the event target's name property.
	 */
	const onHandleChange = (event) => {
		setUsuarioCliente({
			...UsuarioCliente,
			[event.target.name]: event.target.value,
		});
	};

	const getLocalidades = async () => {
		await axios({
			method: 'get',
			url: window.ipdirection + 'localidadAll/',
		}).then((response) => {
			let listaAxu = [];
			const opciones = []
			/* Mapping the response data and pushing it into an array. */
			response.data.forEach((localidad) => {
				listaAxu.push({
					id: localidad.id,
					nombre: localidad.nombre,
					provincia: localidad.provincia,
					codigoPostal: localidad.codigoPostal,
				});
				opciones.push({
					value: localidad.id,
					label: localidad.nombre
				});
			});
			setListaLocalidades(listaAxu)
			setListaLocalidadesOpciones(opciones)
		});
	};

	const [localidadSeleccionada, setLocalidadSeleccionada] = useState(null);
	
	const seleccionarLocalidad = (option) => {
		setLocalidadSeleccionada(option);
		let localidad = ListaLocalidades.find(localidad => localidad.id === option.value);
		setUsuarioCliente({...UsuarioCliente, localidad: localidad}); 
	};

	useEffect(() => {
		if( ListaLocalidades.length === 0) getLocalidades();
	}, []);




	/**
	 * It takes a user object as a parameter, creates a new FormData object, appends the user's profile
	 * picture, the name of the picture, and the user's id to the FormData object, and then sends the
	 * FormData object to the server
	 *
	 * @param {Object} usuario - The user object containing the access token and user data.
	 */
	const enviarFotoPerfil = (usuario) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'clienteByCliente/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		}).then((response) => {
			let user = response.data[0];
			setUsuario({...usuario, cliente: response.data[0]});
			const formData = new FormData();
			const imagenOriginal = new Image(); // Crear un objeto imagen
			imagenOriginal.src = URL.createObjectURL(FotoPerfil.fotoPerfil); // Cargar la imagen en el objeto

			// Esperar a que la imagen se cargue
			imagenOriginal.onload = () => {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');

				// Definir la resolución deseada
				const ancho = 300; // ancho deseado
				const alto = 300; // alto deseado

				canvas.width = ancho;
				canvas.height = alto;

				// Set image scale
				let scaleFactor = Math.max(
					canvas.width / imagenOriginal.width,
					canvas.height / imagenOriginal.height
				);

				// Finding the new width and height based on the scale factor
				let newWidth = imagenOriginal.width * scaleFactor;
				let newHeight = imagenOriginal.height * scaleFactor;

				// get the top left position of the image
				// in order to center the image within the canvas
				let x = canvas.width / 2 - newWidth / 2;
				let y = canvas.height / 2 - newHeight / 2;

				ctx.drawImage(imagenOriginal, x, y, newWidth, newHeight);

				canvas.toBlob((blob) => {
					//formData.append("documento", File);
					formData.append('imagen', blob, usuario.email + '.png');
					formData.append('nombre', 'FotoPerfil-' + usuario.email);
					//formData.append("nombre", "Prueba");
					formData.append('usuario_id', user.usuario.id);

					return new Promise((resolve, reject) => {
						axios
							.post(window.ipdirection + 'imagenPerfilCliente/', formData, {
								headers: {
									Authorization: 'Bearer ' + usuario.access,
								},
							})
							.then((response) => {
								/////////////////////////////
								///Modal
								///////////////////

								navigate('/');
							})
							.then(() => {
								resolve();
							})
							.catch((error) => {
								setErroresFormulario(['Error al enviar la foto de perfil']);
								setModalErrores(true);
								reject(error);
							});
					});
				});
			};
		});
	};
	/**
	 * It checks if the form is valid and if it is, it creates a new user
	 */
	const controlFormulario = () => {
		let listaErrores = {};

		const {nombre, apellidos, telefono, email, password, password2} = UsuarioCliente;

		/*
       /* *|MARKER_CURSOR|* */
		if (password !== password2) {
			listaErrores.contraseña = 'Las contraseñas no coinciden';
		}

		/* Checking if the password is valid. */
		if (!constraseñaErronea(password)) {
			listaErrores.contraseña = 'La contraseña es errónea';
		}

		/* Checking if the email is valid. */
		if (!emailErroneo(email)) {
			listaErrores.email = 'El email introducido es erróneo';
		}

		/* Checking if the phone number is valid. */
		if (!telefonoErroneo(telefono)) {
			listaErrores.telefono = 'El teléfono introducido es erróneo';
		}

		/* Checking if the value of the field is empty. */
		if (!datosVacio(nombre) || !datosVacio(apellidos)) {
			listaErrores.nombre = 'El nombre y los apellidos no pueden estar vacíos';
		}

		if (!PoliticaPrivacidad) {
			listaErrores.politicaPrivacidad = 'Debe de aceptar nuestra política de privacidad';
		}
		// if (FotoPerfil.fotoPerfil === null) {
		// 	listaErrores.push('Debe de agregar un foto de perfil en formato png, jpg o jpeg');
		// } else if (FotoPerfil.fotoPerfil === undefined) {
		// 	listaErrores.push('Debe de agregar un foto de perfil en formato png, jpg o jpeg');
		// } else if (
		// 	FotoPerfil.fotoPerfil.type.toString() !== 'image/jpg' &&
		// 	FotoPerfil.fotoPerfil.type.toString() !== 'image/png' &&
		// 	FotoPerfil.fotoPerfil.type.toString() !== 'image/jpeg'
		// ) {
		// 	listaErrores.push('La foto de perfil debe estar en formato png, jpg o jpeg');
		// }

		/* Checking if the list of errors is empty. If it is empty, it will create a user. If it is not
        empty, it will set the errors in the form and set the modal errors to true. */
		if (Object.keys(listaErrores).length === 0) {
			/* Creating a new user. */
			registrarCliente();
			setEnviando(true);
		} else {
			/* Setting the error message error form to be displayed in the modal. */
			setErroresFormulario(listaErrores);
		}
	};

	const sendEmailNewPaciente = (id, access) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'sendEmailNewPaciente/?paciente_id=' + id,
			headers: {
				Authorization: 'Bearer ' + access,
			},
		})
			.then((response) => {})
			.catch((error) => {
				console.log(error);
			});
	};

	const nuevoPaciente = async (user, access) => {
		let data = {
			nombrePaciente: 'Yo',
			apellidosPaciente: '',
			dniPaciente: '',
			provincia: UsuarioCliente.localidad.provincia.nombre,
			localidad: UsuarioCliente.localidad,
			codigoPostalPaciente: UsuarioCliente.localidad.codigoPostal[0],
			direccionPaciente: UsuarioCliente.direccion,
			telefonoPaciente: UsuarioCliente.telefono,
			numeroSS: '',
			estadoCivil: false,
			fechaNacimiento: '1960-06-06',
			usuario_id: user.usuario.id,
		};
		//delete data.fotoPaciente;
		await axios({
			method: 'post',
			url: window.ipdirection + 'pacienteByCliente/',
			data: data,
			headers: {
				Authorization: 'Bearer ' + access,
			},
		})
			.then((response) => {
				axios({
					method: 'post',
					url: window.ipdirection + 'api/enviar-datos-cliente/',
					data: {
						nombre: UsuarioCliente.nombre,
						apellidos: UsuarioCliente.apellidos,
						email: UsuarioCliente.email,
						telefono: UsuarioCliente.telefono,
						localidad: UsuarioCliente.localidad.nombre,
					},}).then((response) => {
						navigate('/miPerfil')
					})
				// cambiarFotoPerfil(response.data.data.id);
				//sendEmailNewPaciente(response.data.data.id, access);
				
			})
			.catch((error) => {
				alert([error]);
			});
	};
	/**
	 * It sends a POST request to the server with the email and password, and if the response is
	 * successful, it sets the user's data in the state
	 */
	const login = async (email, password) => {
		const response = await axios({
			method: 'post',
			url: window.ipdirection + 'auth/login/',
			data: {
				email: email,
				password: password,
			},
		})

		if (response) {
			let usuario = {
				access: response.data.access,
				refresh: response.data.refresh,
				tipo: 'usuarioNormal',
			};
			
			const res = await axios({
			method: 'get',
			url: window.ipdirection + 'clienteByCliente/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
			}).then((response) => {
				let user = response.data[0];
				setUsuario({...usuario, cliente: user});
				nuevoPaciente(user, usuario.access);
			}).catch((error) => {
				alert('error', error);
			});
		}
		// }).then((response) => {
		// 	// let usuario = {
		// 	// 	access: response.data.access,
		// 	// 	refresh: response.data.refresh,
		// 	// 	tipo: 'usuarioNormal',
		// 	// };
		// 	//enviarFotoPerfil(usuario);
		// 	let res = await response.data;

		// 	navigate('/miPerfil');
			
		// 	//setModalRegistrarPaciente(true)
		// });
	};

	/**
	 * A function that registers a client in the database.
	 */
	const registrarCliente = () => {
		const {nombre, apellidos, telefono, email, password, password2, username} = UsuarioCliente;
		let data = {
			nombre: nombre,
			apellidos: apellidos,
			telefono: telefono,
			usuario: {
				email: email,
				password: password,
				username: email,
			},
		};
		axios({
			method: 'post',
			url: window.ipdirection + 'cliente/',

			data: data,
		})
			.then((response) => {
				
				login(email, password);
			})
			.catch((error) => {
				let lista = [];
				let dat = error.response.data.usuario;
				for (const key in dat) {
					lista.push(dat[key]);
				}
				ErroresFormulario.email = lista;
				setEnviando(false);
			});
	};

	const [NumInput, setNumInput] = useState(0);

	const inpust = ['email', 'password', 'password2', 'nombre', 'apellidos', 'telefono'];
	useEffect(() => {
		if (NumInput === 6) {
			controlFormulario();
		}
	}, [NumInput]);

	const changeFocus = (event) => {
		if (event.key === 'Enter' || event.key === 'ArrowDown') {
			if (NumInput < 5 && NumInput >= 0) {
				setNumInput(NumInput + 1);
				let nextInputName = inpust[NumInput + 1];
				document.getElementById(nextInputName).focus();
			}
		} else if (event.key === 'ArrowUp') {
			setNumInput(NumInput - 1);
			let nextInputName = inpust[NumInput - 1];
			document.getElementById(nextInputName).focus();
		}
	};
	const changeFocusClick = (event) => {
		let contador = 0;
		inpust.map((input) => {
			if (input === event.target.name) {
				document.getElementById(input).focus();
				setNumInput(contador);
			}
			contador++;
		});
	};

	return (
		// <>
		// 	<ModalesRegistro
		// 		ModalErrores={ModalErrores}
		// 		setModalErrores={setModalErrores}
		// 		ErroresFormulario={ErroresFormulario}
		// 		setErroresFormulario={setErroresFormulario}
		// 		setModalRegistrarPaciente={setModalRegistrarPaciente}
		// 		ModalRegistraPaciente={ModalRegistraPaciente}
		// 	/>

		// 	<div className='formUsuReg'>
		// 		<div className='contentFormularioUsuarioPacientes'>
		// 			<div className='logoLateral'>
		// 				<div className='centrador'>
		// 					<img src={logo} />
		// 				</div>
		// 			</div>
		// 			<div className='formRegistroDatos'>
		// 				<div className='centradorLeft'>
		// 					<h2>
		// 						<b>Registrarse</b>
		// 					</h2>
		// 				</div>
		// 				<div className='separador' />
		// 				<br />
		// 				<div className='datoFormularioUsuarioRegistro'>
		// 					<div className='label-formulario-registro'>
		// 						<div>
		// 							<b>Email</b>
		// 						</div>
		// 						<div>
		// 							<svg
		// 								xmlns='http://www.w3.org/2000/svg'
		// 								width='10'
		// 								height='10'
		// 								fill='currentColor'
		// 								class='bi bi-asterisk'
		// 								viewBox='0 0 16 16'
		// 							>
		// 								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
		// 							</svg>
		// 						</div>
		// 					</div>
		// 					<div className='inputRegistro'>
		// 						<input
		// 							type='email'
		// 							Id='email'
		// 							className='inputTextUsuario'
		// 							placeholder='email@ejemplo.com'
		// 							name='email'
		// 							onChange={(event) => onHandleChange(event)}
		// 							onClick={(event) => changeFocusClick(event)}
		// 							onKeyDown={(event) => changeFocus(event)}
		// 						/>
		// 					</div>
		// 				</div>
		// 				<div className='datoFormularioUsuarioRegistro'>
		// 					<div className='label-formulario-registro'>
		// 						<div>
		// 							<b>Contraseña</b>
		// 						</div>
		// 						<div>
		// 							<svg
		// 								xmlns='http://www.w3.org/2000/svg'
		// 								width='10'
		// 								height='10'
		// 								fill='currentColor'
		// 								class='bi bi-asterisk'
		// 								viewBox='0 0 16 16'
		// 							>
		// 								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
		// 							</svg>
		// 						</div>
		// 					</div>
		// 					<div className='inputRegistro'>
		// 						<input
		// 							type='password'
		// 							Id='password'
		// 							className='inputTextUsuario'
		// 							placeholder='***********'
		// 							name='password'
		// 							onChange={(event) => onHandleChange(event)}
		// 							onClick={(event) => changeFocusClick(event)}
		// 							onKeyDown={(event) => changeFocus(event)}
		// 						/>
		// 					</div>
		// 				</div>
		// 				<div className='datoFormularioUsuarioRegistro'>
		// 					<div className='label-formulario-registro'>
		// 						<div>
		// 							<b>Repita la contraseña</b>
		// 						</div>
		// 						<div>
		// 							<svg
		// 								xmlns='http://www.w3.org/2000/svg'
		// 								width='10'
		// 								height='10'
		// 								fill='currentColor'
		// 								class='bi bi-asterisk'
		// 								viewBox='0 0 16 16'
		// 							>
		// 								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
		// 							</svg>
		// 						</div>
		// 					</div>
		// 					<div className='inputRegistro'>
		// 						<input
		// 							type='password'
		// 							Id='password2'
		// 							className='inputTextUsuario'
		// 							placeholder='***********'
		// 							name='password2'
		// 							onChange={(event) => onHandleChange(event)}
		// 							onClick={(event) => changeFocusClick(event)}
		// 							onKeyDown={(event) => changeFocus(event)}
		// 						/>
		// 					</div>
		// 				</div>
		// 				<br />
		// 				<div className='separador' />
		// 				<br />
		// 				<div className='datoFormularioUsuarioRegistro'>
		// 					<div className='label-formulario-registro'>
		// 						<div>
		// 							<b>Nombre</b>
		// 						</div>
		// 						<div>
		// 							<svg
		// 								xmlns='http://www.w3.org/2000/svg'
		// 								width='10'
		// 								height='10'
		// 								fill='currentColor'
		// 								class='bi bi-asterisk'
		// 								viewBox='0 0 16 16'
		// 							>
		// 								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
		// 							</svg>
		// 						</div>
		// 					</div>
		// 					<div className='inputRegistro'>
		// 						<input
		// 							type='first'
		// 							Id='nombre'
		// 							className='inputTextUsuario'
		// 							placeholder='Nombre'
		// 							name='nombre'
		// 							onChange={(event) => onHandleChange(event)}
		// 							onClick={(event) => changeFocusClick(event)}
		// 							onKeyDown={(event) => changeFocus(event)}
		// 						/>
		// 					</div>
		// 				</div>
		// 				<div className='datoFormularioUsuarioRegistro'>
		// 					<div className='label-formulario-registro'>
		// 						<div>
		// 							<b>Apellidos</b>
		// 						</div>
		// 						<div>
		// 							<svg
		// 								xmlns='http://www.w3.org/2000/svg'
		// 								width='10'
		// 								height='10'
		// 								fill='currentColor'
		// 								class='bi bi-asterisk'
		// 								viewBox='0 0 16 16'
		// 							>
		// 								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
		// 							</svg>
		// 						</div>
		// 					</div>
		// 					<div className='inputRegistro'>
		// 						<input
		// 							type='last_name'
		// 							Id='apellidos'
		// 							className='inputTextUsuario'
		// 							placeholder='Apellidos'
		// 							name='apellidos'
		// 							onChange={(event) => onHandleChange(event)}
		// 							onClick={(event) => changeFocusClick(event)}
		// 							onKeyDown={(event) => changeFocus(event)}
		// 						/>
		// 					</div>
		// 				</div>

		// 				<div className='datoFormularioUsuarioRegistro'>
		// 					<div className='label-formulario-registro'>
		// 						<div>
		// 							<b>Teléfono</b>
		// 						</div>
		// 						<div>
		// 							<svg
		// 								xmlns='http://www.w3.org/2000/svg'
		// 								width='10'
		// 								height='10'
		// 								fill='currentColor'
		// 								class='bi bi-asterisk'
		// 								viewBox='0 0 16 16'
		// 							>
		// 								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
		// 							</svg>
		// 						</div>
		// 					</div>
		// 					<div className='inputRegistro'>
		// 						<input
		// 							type='phone'
		// 							Id='telefono'
		// 							className='inputTextUsuario'
		// 							placeholder='663662661'
		// 							name='telefono'
		// 							onChange={(event) => onHandleChange(event)}
		// 							onClick={(event) => changeFocusClick(event)}
		// 							onKeyDown={(event) => changeFocus(event)}
		// 						/>
		// 					</div>
		// 				</div>
		// 				<br />
		// 				<div className='separador' />
		// 				<br />
		// 				<div className='datoFormularioUsuarioRegistro'>
		// 					<div className='label-formulario-registro'>
		// 						<div>
		// 							<b>Imagen de perfil</b>
		// 						</div>
		// 						<div>
		// 							<svg
		// 								xmlns='http://www.w3.org/2000/svg'
		// 								width='10'
		// 								height='10'
		// 								fill='currentColor'
		// 								class='bi bi-asterisk'
		// 								viewBox='0 0 16 16'
		// 							>
		// 								<path d='M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z' />
		// 							</svg>
		// 						</div>
		// 					</div>
		// 					<input
		// 						type='file'
		// 						className='inputTextUsuario inputFile'
		// 						accept='image/*'
		// 						onChange={(e) =>
		// 							setFotoPerfil({
		// 								...FotoPerfil,
		// 								fotoPerfil: e.target.files[0],
		// 							})
		// 						}
		// 					/>
		// 				</div>
		// 				<div className='politica-privacidad-usuario'>
		// 					<div className='centrador'>
		// 						<Checkbox
		// 							checked={PoliticaPrivacidad}
		// 							onChange={(event) => setPoliticaPrivacidad(!PoliticaPrivacidad)}
		// 							sx={{
		// 								color: '23C290',
		// 								'&.Mui-checked': {color: '#23C290'},
		// 							}}
		// 						/>
		// 					</div>
		// 					<div
		// 						className='link-politica-privacidad-empresas centrador'
		// 						onClick={() => setMostartPoliticaPrivacidad(true)}
		// 					>
		// 						Acepto la política de privacidad
		// 					</div>
		// 				</div>
		// 				<div className='centradorRight'>
		// 					<div
		// 						className='button'
		// 						onClick={controlFormulario}
		// 					>
		// 						<b>Registro</b>
		// 					</div>
		// 				</div>
		// 				<div className='separador' />
		// 				<div className='link-politica-privacidad-empresas centrador '>
		// 					<div
		// 						onClick={() => {
		// 							navigate('/login');
		// 						}}
		// 					>
		// 						<b>Inicie sesión aquí</b>
		// 					</div>
		// 				</div>
		// 			</div>
		// 		</div>
		// 	</div>
	<>
		<div className="">
			<div className="row min-vh-80">
				<div className="col-lg-4 d-none d-lg-block logoLateral">
					<div className="centrador text-center">
						<img src={logo} alt="Logo" className="img-fluid w-50" />
					</div>
				</div>
				<div className="col-lg-8 col-md-12 d-flex align-items-center justify-content-center">
				<div className="w-100" style={{ maxWidth: '530px', backgroundColor: '#fff', padding: '2rem', borderRadius: '12px', boxShadow: '0 0 15px rgba(0,0,0,0.05)'  }}>
					<h2 className="mb-4">Área de Clientes</h2>
					<div>
						
						<div className="mb-3">
							<label htmlFor="email" className="form-label">Correo Electrónico</label>
							<input type="email" id="email" name='email' placeholder="nombre@ejemplo.com" required 
								className={`form-control text-dark ${ErroresFormulario.email ? "border border-danger" : ""}`}
								onChange={(event) => onHandleChange(event)}
								onClick={(event) => changeFocusClick(event)}
								onKeyDown={(event) => changeFocus(event)}
							/>
							{
								ErroresFormulario.email &&
								<div className="text-danger small mt-1">
									{ErroresFormulario.email}
								</div>
							}
						</div>

						<div className="row mb-3">
                    	<div className="col-md-6 mb-1">
							<label htmlFor="password" className="form-label">Contraseña</label>
							<div className='input-group'>
								<input type={showPassword ? "text" : "password"} id="password" name='password' placeholder="********" required 
									className={`form-control text-dark ${ErroresFormulario.contraseña ? "border border-danger" : ""}`}
									onChange={(event) => onHandleChange(event)}
									onClick={(event) => changeFocusClick(event)}
									onKeyDown={(event) => changeFocus(event)}
								/>
								<button
									type="button"
									className="btn btn-outline-secondary"
									onClick={mostrarPassword}
									tabIndex={-1}
									>
									{showPassword ? "Ocultar" : "Mostrar"}
								</button>
							</div>
						</div>

						<div className="col-md-6 mb-1">
							<label htmlFor="confirmPassword" className="form-label">Confirmar Contraseña</label>
							<div className='input-group'>
								<input type={showPassword2 ? "text" : "password"} id="confirmPassword" name='password2' placeholder="********" required 
									className={`form-control text-dark ${ErroresFormulario.contraseña ? "border border-danger" : ""}`}
									onChange={(event) => onHandleChange(event)}
									onClick={(event) => changeFocusClick(event)}
									onKeyDown={(event) => changeFocus(event)}
								/>
								<button
									type="button"
									className="btn btn-outline-secondary"
									onClick={mostrarPassword2}
									tabIndex={-1}
									>
									{showPassword2 ? "Ocultar" : "Mostrar"}
								</button>
							</div>
						</div>
						{
							ErroresFormulario.contraseña &&
							<div className="text-danger small mb-1">
								{ErroresFormulario.contraseña}
							</div>
						}   
						<small className="text-muted">
							La contraseña debe tener al menos 6 caracteres, una mayúscula, una minúscula y un número.
						</small>
						</div>

						<div className="row mb-3">
                    		<div className="col-md-6 mb-1">
								<label htmlFor="nombre" className="form-label">Nombre</label>
								<input type="text" id="nombre" name='nombre' placeholder="Ingresa tu nombre" required 
									className={`form-control text-dark ${ErroresFormulario.nombre ? "border border-danger" : ""}`}
									onChange={(event) => onHandleChange(event)}
									onClick={(event) => changeFocusClick(event)}
									onKeyDown={(event) => changeFocus(event)}
								/>
							</div>

							<div className="mb-1 col-md-6">
								<label htmlFor="apellidos" className="form-label">Apellidos</label>
								<input type="text" id="apellidos" name='apellidos' placeholder="Ingresa tu nombre" required 
									className={`form-control text-dark ${ErroresFormulario.nombre ? "border border-danger" : ""}`}
									onChange={(event) => {onHandleChange(event)}}
									onClick={(event) => changeFocusClick(event)}
									onKeyDown={(event) => changeFocus(event)}
								/>
							</div>
							{
								ErroresFormulario.nombre &&
								<div className="text-danger small mt-1">
									{ErroresFormulario.nombre}
								</div>
							}
						</div>

						<div className="mb-3">
							<label htmlFor="telefono" className="form-label">Teléfono</label>
							<input type="tel" id="telefono" name='telefono' placeholder="+34 600 000 000" required 
								className={`form-control text-dark ${ErroresFormulario.telefono ? "border border-danger" : ""}`}
								onChange={(event) => onHandleChange(event)}
								onClick={(event) => changeFocusClick(event)}
								onKeyDown={(event) => changeFocus(event)}
							/>
							{
								ErroresFormulario.telefono &&
								<div className="text-danger small mt-1">
									{ErroresFormulario.telefono}
								</div>
							}
						</div>

						<div className="mb-3">
							<label htmlFor="localidad" className="form-label">Localidad</label>
							<Select
								className={`text-dark ${ErroresFormulario.localidadSeleccionada ? "border border-danger" : ""}`}
								options={ListaLocalidadesOpciones}
								value={localidadSeleccionada}
								onChange={seleccionarLocalidad}
								placeholder="Localidad"
								isClearable
							/>
							{
							ErroresFormulario.localidadSeleccionada &&
								<div className="text-danger small mt-1">
									{ErroresFormulario.localidadSeleccionada}
								</div>
							}
						</div>

						<div className="mb-3">
							<label htmlFor="direccion" className="form-label">Dirección</label>
							<input type="text" id="direccion" name='direccion' placeholder="dirección" required 
								className={`form-control text-dark ${ErroresFormulario.direccion ? "border border-danger" : ""}`}
								onChange={(event) => onHandleChange(event)}
								onClick={(event) => changeFocusClick(event)}
								onKeyDown={(event) => changeFocus(event)}
							/>
							{
								ErroresFormulario.direccion &&
								<div className="text-danger small mt-1">
									{ErroresFormulario.direccion}
								</div>
							}
						</div>
						
						<div className="d-flex align-items-center mt-2">
							<div className="centrador">
								<Checkbox
									className={`${ErroresFormulario.contraseña ? "border border-danger" : ""}`}
									checked={PoliticaPrivacidad}
									onChange={(event) => setPoliticaPrivacidad(!PoliticaPrivacidad)}
									sx={{
										color: '#23C290',
										'&.Mui-checked': {color: '#23C290'},
									}}
								/>
							</div>
							<div
                            className='link-politica-privacidad-empresas centrador'
								onClick={() => navigate('/politica-privacidad')}
							>
								Acepto la política de privacidad
							</div>
						</div>
						{
							ErroresFormulario.politicaPrivacidad &&
							<div className="text-danger small mt-1">
								{ErroresFormulario.politicaPrivacidad}
							</div>
						}
						<div className="d-grid mt-4">
							<button className="btn btn-primary fw-bold"
								disabled={enviando}
								onClick={controlFormulario}
							>
								Registrarse
							</button>
						</div>
					</div>
					<div className='separador my-3' />
					<div className='link-politica-privacidad-empresas centrador '>
		 					<div
		 						onClick={() => {
		 							navigate('/login');
		 						}}
		 					>
		 						<b>Inicie sesión aquí</b>
		 					</div>
		 				</div>
				</div>
				</div>
			</div>
		</div>
	</>
	);
};
